import { KeyRound } from "lucide-react";

// Login-help note for students/staff searching "<institution> acadmax login". No institution URLs until owner-verified.
export const AcadmaxLoginNote = () => (
  <section className="py-14" data-testid="acadmax-login-note">
    <div className="max-w-4xl mx-auto px-6">
      <div className="card-clean p-6 md:p-8 flex gap-5 items-start">
        <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <KeyRound className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-base md:text-lg" data-testid="acadmax-login-note-title">
            Looking for Your Institution&apos;s AcadMax Login?
          </h2>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed" data-testid="acadmax-login-note-body">
            This page is for institutions evaluating AcadMax. If you are a student, faculty member or staff member,
            please sign in through the official AcadMax portal provided by your institution — your university or
            college IT office can share the correct link.
          </p>
        </div>
      </div>
    </div>
  </section>
);
